module.exports = __webpack_public_path__ + "static/img/FM.643760f6.svg";